<template>
    <!--弹窗-->
    <el-dialog
        width="70%"
        title="类目列表"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-table
            v-loading="loading"
            :data="sendList"
            class="table_content"
            size="mini"
            height="600"
            border
            style="width: 100%;">
            <el-table-column label="1688产品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.pic_url" v-else/>
                </template>
            </el-table-column>
            <el-table-column
                label="1688产品标题"
                :resizable="false"
                prop="title"
                align="center">
            </el-table-column>
            <el-table-column
                label="1688产品链接"
                :resizable="false"
                prop="detail_url"
                align="center">
            </el-table-column>
            <el-table-column
                label="1688产品价格"
                :resizable="false"
                prop="price"
                width="120"
                align="center">
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                width="150">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.detail_url" type="primary" size="mini"
                               @click="jumpUrl(scope.row.detail_url)">跳转
                    </el-button>

                    <el-button type="success" size="mini" @click.native="chooseItem(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--        <el-pagination-->
        <!--            @size-change="handleSizeChange"-->
        <!--            @current-change="handleCurrentChange"-->
        <!--            :page-size="query.limit"-->
        <!--            :page-sizes="[10, 50, 100]"-->
        <!--            :total="query.total"-->
        <!--            background-->
        <!--            style="float: right;margin-top: 10px; margin-bottom: 5px"-->
        <!--            layout="total, sizes, prev, pager, next"-->
        <!--        >-->
        <!--        </el-pagination>-->
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {reference_index_search_ali_result} from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            list: [],
            loading: false,
            query: {
                page: 1,
                limit: 10,
                total: 0,
            },
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        sendList: {
            type: Array,
            default: []
        }
    },
    methods: {
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        chooseItem(data) {
            this.$emit('choose1688Info', {data: JSON.parse(JSON.stringify(data))})
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.get1688List()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.get1688List()
        },
        get1688List() {
            // this.loading = true
            // api.reference_index_search_ali_result({id: this.copyData.id}).then(res => {
            //     if (res.code === 0) {
            //         const responseList = res.data || []
            //         this.list = responseList
            //         this.query.total = res.data.total || 0
            //     } else {
            //         this.$message({type: 'error', message: res.message})
            //     }
            // }).catch(() => {
            //     this.loading = false
            // }).finally(() => {
            //     this.loading = false
            // })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
